export class EnquiryAssessmentInfoModel{
    enquiryId:number;
    enquiryNumber:string;
    sourceFrom:string;
    agent:string;
    buyer:string;
    deliveryDate:Date;
    unit:string;
    country:string;
    destination:string;
    enquiryDate: any;
    lifeCycleStatus : string

    constructor(enquiryId:number,enquiryNumber:string,sourceFrom:string,agent:string,buyer:string,deliveryDate:Date,unit:string,country:string,destination:string,enquiryDate: any,lifeCycleStatus : string){
    this.enquiryId = enquiryId
    this.enquiryNumber = enquiryNumber
    this.sourceFrom = sourceFrom
    this.agent = agent
    this.buyer = buyer
    this.deliveryDate = deliveryDate
    this.unit = unit
    this.country = country
    this.destination = destination
    this.enquiryDate = enquiryDate
    this.lifeCycleStatus = lifeCycleStatus
    }
}